require('./scroll-slider');
require('./swipe-slider');
require('./rslider');
require('./product-base-top-slider');
require('./product-slider');
require('./article-slider');
require('./actions-slider');
require('./compare-slider');